// Maison Gonfier – case « Livraison Premium » dans le panier latéral (Claude, 03/11/2026).
import { CartUpdatedEvent } from '@theme/events';

class MgLivraisonPremium extends HTMLElement {
  constructor() {
    super();
    this.changeHandler = this.#onChange.bind(this);
  }

  connectedCallback() {
    this.checkbox = this.querySelector('[data-ref="mg-lp-checkbox"]');
    this.checkbox?.addEventListener('change', this.changeHandler);

    const quantity = parseInt(this.dataset.quantity || '0', 10);
    const otherItems = parseInt(this.dataset.otherItems || '0', 10);

    // Panier sans autre article : on retire l'option toute seule.
    if (quantity > 0 && otherItems === 0) {
      this.#update(0);
    } else if (quantity > 1) {
      // Jamais plus d'une option par commande.
      this.#update(1);
    }
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this.changeHandler);
  }

  #onChange() {
    this.#update(this.checkbox.checked ? 1 : 0);
  }

  #sectionId() {
    return this.closest('cart-drawer')?.dataset.sectionId;
  }

  async #update(quantity) {
    const sectionId = this.#sectionId();
    this.classList.add('mg-lp--busy');

    try {
      const response = await fetch(Theme.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: String(this.dataset.variantId),
          quantity,
          sections: sectionId,
          sections_url: window.location.pathname,
        }),
      });
      let data = await response.json();

      // /cart/change refuse une ligne absente du panier : dans ce cas on l'ajoute.
      if (!response.ok && quantity > 0) {
        const addResponse = await fetch(Theme.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(this.dataset.variantId), quantity: 1 }],
            sections: sectionId,
            sections_url: window.location.pathname,
          }),
        });
        data = await addResponse.json();
        if (!addResponse.ok) throw new Error(data.description || data.message || 'cart add failed');
      } else if (!response.ok) {
        throw new Error(data.description || data.message || 'cart change failed');
      }

      // Nombre d'articles hors option Livraison Premium.
      let itemCount = parseInt(this.dataset.otherItems || '0', 10);
      if (Array.isArray(data.items) && typeof data.item_count === 'number') {
        const variantId = Number(this.dataset.variantId);
        itemCount = data.items.reduce(
          (count, item) => (item.variant_id === variantId ? count : count + item.quantity),
          0,
        );
      }

      document.dispatchEvent(
        new CartUpdatedEvent({}, { itemCount, source: 'mg-livraison-premium', sections: data.sections }),
      );
    } catch (error) {
      console.error(error);
      if (this.checkbox) this.checkbox.checked = !this.checkbox.checked;
      this.classList.remove('mg-lp--busy');
      document.dispatchEvent(
        new CustomEvent('toast:open', {
          detail: { type: 'error', message: 'Une erreur est survenue, veuillez réessayer.' },
        }),
      );
    }
  }
}

if (!customElements.get('mg-livraison-premium')) {
  customElements.define('mg-livraison-premium', MgLivraisonPremium);
}
